import { MODAL_UPGRADE_PLAN } from '@components/App/Modal/constants'
import { useMediaQuery } from '@lib/hooks'
import type { ID } from '@octopus-do/octopus-project-core'
import { openModal } from '@storeOld/reducers/ui'
import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'

import { GtmTriggerName, sendGtmEvent } from '@/constants/gtm'
import { TABLET_LANDSCAPE_MEDIA } from '@/constants/media'
import { useAuth } from '@/hooks'
import { HIDE_BADGE_PLAN_TYPES } from './constants'

export const useWorkspacesDropdown = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const { planId } = useAuth()

  const desktop = useMediaQuery(TABLET_LANDSCAPE_MEDIA)

  const handleOnClick = (id: ID) => {
    navigate(`/dashboard/${id}`)
  }

  const handleCreateSpace = () => {
    sendGtmEvent(GtmTriggerName.UPGRADE_TEAM)

    dispatch(
      openModal({
        modalType: MODAL_UPGRADE_PLAN,
        modalProps: {
          planType: 'team',
          slideType: 'team',
        },
      })
    )
  }

  const offsetY = !desktop ? -28 : 8

  const showCreateTeamBtn = !HIDE_BADGE_PLAN_TYPES.includes(planId)

  return {
    offsetY,
    desktop,
    showCreateTeamBtn,
    handleOnClick,
    handleCreateSpace,
  }
}
